<button
  #userMenuTrigger
  id="user-menu-button"
  type="button"
  class="user-menu-trigger"
  [class.user-menu-trigger--active]="panelOpen"
  [attr.aria-expanded]="panelOpen"
  aria-controls="user-profile-panel"
  (click)="openPanel($event)"
>
  <span class="sr-only">{{ "APP_USER.ACCOUNT_MENU" | translate }}</span>
  <app-user-avatar [name]="displayName" [url]="myAvatarUrl" [size]="30"></app-user-avatar>
</button>

<div
  #panelRoot
  class="user-panel-root"
  [class.user-panel-root--open]="panelOpen"
  [class.user-panel-root--rtl]="isRTL"
  [ngStyle]="panelStyle"
>
  <aside
    *ngIf="panelOpen"
    id="user-profile-panel"
    class="user-panel"
    role="menu"
    [attr.aria-label]="'APP_USER.ACCOUNT_MENU' | translate"
  >
    <div class="user-panel__head">
      <app-user-avatar [name]="displayName" [url]="myAvatarUrl" [size]="42" aria-hidden="true"></app-user-avatar>
      <div class="user-panel__identity">
        <div class="user-panel__name">{{ displayName }}</div>
        <div *ngIf="profile?.username" class="user-panel__login">{{ profile?.username }}</div>
        <div *ngIf="companyId" class="user-panel__meta">
          {{ "APP_USER.COMPANY_ID" | translate }}: {{ companyId }}
        </div>
      </div>
    </div>

    <div class="user-panel__details">
      <div class="user-panel__detail-row">
        <span class="user-panel__detail-label">{{ "APP_USER.EMAIL" | translate }}</span>
        <span class="user-panel__detail-value" dir="ltr">{{ displayValue(profileEmail) }}</span>
      </div>
      <div class="user-panel__detail-row">
        <span class="user-panel__detail-label">{{ "APP_USER.PHONE" | translate }}</span>
        <span class="user-panel__detail-value" dir="ltr">{{ displayValue(profilePhone) }}</span>
      </div>
      <div *ngIf="agentGroupName" class="user-panel__detail-row">
        <span class="user-panel__detail-label">{{ "APP_USER.AGENT_GROUP" | translate }}</span>
        <span class="user-panel__detail-value">{{ agentGroupName }}</span>
      </div>
    </div>

    <div class="user-panel__footer">
      <button type="button" class="user-panel__logout" role="menuitem" (click)="signout()">
        <app-sidebar-icon name="log-out" [size]="16"></app-sidebar-icon>
        <span>{{ "APP_USER.LOGOUT" | translate }}</span>
      </button>
    </div>
  </aside>
</div>
